/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeMinusIcon20Solid = forwardRef('SearchLoupeMinusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.375 8a1 1 0 1 0 0 2h5.25a1 1 0 0 0 0-2h-5.25Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.126 9.003a7.874 7.874 0 1 1 14.182 4.714l3.364 3.364a1.125 1.125 0 0 1-1.591 1.59l-3.364-3.362A7.874 7.874 0 0 1 1.126 9.004ZM9 3.38a5.624 5.624 0 1 0 0 11.248A5.624 5.624 0 0 0 9 3.38Z" })));
});
